import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiCheckbox: Components<CssVarsTheme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.vars.palette.neutral.main
    })
  }
};
